// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import { dbHelpers } from '../../db/database';
// import { warehousesAPI } from '../../api/warehouses';
// import syncService from '../../services/syncService';
// import { filterWarehouses } from '../../utils/permissions';
// import TrialBanner from '../common/TrialBanner';
// import './Dashboard.css';


// function Dashboard() {
//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const [stats, setStats] = useState({
//     totalProducts: 0,
//     lowStockItems: 0,
//     pendingOrders: 0,
//     activeWarehouses: 0,
//     totalRevenue: 0
//   });
//   const [lowStockProducts, setLowStockProducts] = useState([]);
//   const [recentActivity, setRecentActivity] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [syncing, setSyncing] = useState(false);
//   const [subscriptionData, setSubscriptionData] = useState(null);
//   const [showToast, setShowToast] = useState(false); // ⭐ NEW

// useEffect(() => {
//   loadDashboardData();
//   loadSubscriptionData();
  
//   // ⭐ DEBUG LOGS
//   const isNewUser = sessionStorage.getItem('newRegistration');
  
//   if (isNewUser === 'true') {
//     sessionStorage.removeItem('newRegistration');
//     setShowToast(true);
//     setTimeout(() => {
//       setShowToast(false);
//     }, 5000);
//   } else {
//   }
// }, []);

// async function loadSubscriptionData() {
//   try {
//     const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8009/api';
//     const token = localStorage.getItem('access_token');
    
//     if (!token) {
//       return;
//     }

//     const response = await fetch(`${API_URL}/subscriptions/status/`, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       }
//     });


//     if (response.ok) {
//       const data = await response.json();
//       setSubscriptionData(data);
//     } else {
//     }
//   } catch (error) {
//   }
// }



//   async function loadDashboardData() {
//     setLoading(true);
//     try {
//       // Load all data
//       const [products, stocks, orders, warehousesResponse] = await Promise.all([
//         dbHelpers.getProducts(),
//         dbHelpers.getStocks(),
//         dbHelpers.getOrders(),
//         warehousesAPI.getAll()
//       ]);

//       const warehousesArray = warehousesResponse.data?.results || warehousesResponse.data || [];

//       // ⭐ FILTER: Get accessible warehouses
//       const accessibleWarehouses = filterWarehouses(warehousesArray);
//       const accessibleWarehouseIds = accessibleWarehouses.map(w => w.id);

//       // ⭐ FILTER: Only stocks from accessible warehouses
//       const filteredStocks = stocks.filter(stock =>
//         accessibleWarehouseIds.includes(stock.warehouse_id || stock.warehouse)
//       );

//       // ⭐ FILTER: Only orders from accessible warehouses
//       const filteredOrders = orders.filter(order =>
//         accessibleWarehouseIds.includes(order.warehouse_id || order.warehouse)
//       );

//       // ⭐ FILTER: Only products in accessible warehouses
//       const accessibleProductIds = new Set(
//         filteredStocks.map(stock => stock.product_id || stock.product)
//       );
//       const filteredProducts = products.filter(product =>
//         accessibleProductIds.has(product.id)
//       );
//       // Calculate low stock items
//       const lowStock = filteredStocks.filter(stock => {
//         const quantity = parseInt(stock.quantity) || 0;
//         const reorderLevel = parseInt(stock.reorder_level) || 10;
//         return quantity <= reorderLevel;
//       });

//       // Calculate pending orders
//       const pending = filteredOrders.filter(o => o.status === 'pending' || o.status === 'confirmed');

//       // Calculate revenue (sum of all delivered orders)
//       const revenue = filteredOrders
//         .filter(o => o.status === 'delivered')
//         .reduce((sum, o) => sum + parseFloat(o.total || 0), 0);

//       setStats({
//         totalProducts: filteredProducts.length,
//         lowStockItems: lowStock.length,
//         pendingOrders: pending.length,
//         activeWarehouses: accessibleWarehouses.filter(w => w.is_active !== false).length,
//         totalRevenue: revenue
//       });

//       // Set low stock products with details
//       const lowStockWithDetails = lowStock.map(stock => {
//         const product = filteredProducts.find(p => p.id === (stock.product_id || stock.product));
//         const warehouse = accessibleWarehouses.find(w => w.id === (stock.warehouse_id || stock.warehouse));
//         return {
//           ...stock,
//           product_name: product?.name || stock.product_name || 'Unknown',
//           warehouse_name: warehouse?.name || stock.warehouse_name || 'Unknown',
//         };
//       }).slice(0, 5);

//       setLowStockProducts(lowStockWithDetails);

//       // Generate recent activity
//       generateRecentActivity(filteredOrders, filteredStocks);
//     } catch (error) {
//     }
//     setLoading(false);
//   }

//   function generateRecentActivity(orders, stocks) {
//     const activities = [];

//     // Recent orders
//     const recentOrders = orders
//       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//       .slice(0, 3);

//     recentOrders.forEach(order => {
//       activities.push({
//         type: 'order',
//         message: `Order #${String(order.id).substring(0, 8)} ${order.status}`,
//         time: formatTimeAgo(order.created_at)
//       });
//     });

//     // Recent stock updates (if any)
//     const recentStocks = stocks
//       .filter(s => s.updated_at)
//       .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
//       .slice(0, 2);

//     recentStocks.forEach(stock => {
//       activities.push({
//         type: 'stock',
//         message: `Stock updated: ${stock.product_name} (${stock.quantity} units)`,
//         time: formatTimeAgo(stock.updated_at)
//       });
//     });

//     setRecentActivity(activities);
//   }

//   function formatTimeAgo(timestamp) {
//     if (!timestamp) return 'Just now';
//     const now = Date.now();
//     const time = new Date(timestamp).getTime();
//     const diff = Math.floor((now - time) / 1000); // seconds

//     if (diff < 60) return 'Just now';
//     if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
//     if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
//     return `${Math.floor(diff / 86400)} days ago`;
//   }

//   async function handleSync() {
//     setSyncing(true);
//     const result = await syncService.fullSync();
//     if (result.success) {
//       await loadDashboardData();
//     }
//     setSyncing(false);
//   }

//   function getStockStatus(quantity, reorderLevel) {
//     const qty = parseInt(quantity) || 0;
//     const reorder = parseInt(reorderLevel) || 10;
//     if (qty === 0) return 'OUT OF STOCK';
//     if (qty <= reorder) return 'LOW STOCK';
//     return 'IN STOCK';
//   }

//   if (loading) {
//     return (
//       <div className="dashboard">
//         <div className="loading-state">
//           <div className="spinner"></div>
//           <p>Loading dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard fade-in">
//       {/* ⭐ WELCOME TOAST */}
//       {showToast && (
//         <div className="welcome-toast">
//           <div className="toast-icon">🎉</div>
//           <div className="toast-content">
//             <strong>Welcome to TaalumaERP!</strong>
//             <p>Your 14-day free trial has started. Explore all features!</p>
//           </div>
//           <button className="toast-close" onClick={() => setShowToast(false)}>×</button>
//         </div>
//       )}

//       {/* ⭐ Trial Banner - Pass subscription data */}
//       <TrialBanner subscriptionData={subscriptionData} />

//       {/* ⭐ Dashboard Header - Clean Layout */}
//       <div className="dashboard-header">
//         <div className="header-content">
//           <h1>Dashboard</h1>
//           <p className="welcome-text">Welcome back, {user?.organization?.name || user?.username}!</p>
//         </div>
//         <button
//           onClick={handleSync}
//           className="btn-sync"
//           disabled={syncing}
//         >
//           {syncing ? '⟳ Syncing...' : '🔄 Sync'}
//         </button>
//       </div>

//       {/* Low Stock Alert */}
//       {stats.lowStockItems > 0 && (
//         <div className="alert-banner alert-warning">
//           <span className="alert-icon">⚠️</span>
//           <div className="alert-content">
//             <strong>{stats.lowStockItems} products below reorder level!</strong>
//             <p>
//               {lowStockProducts.map(s => s.product_name).slice(0, 2).join(', ')}
//               {lowStockProducts.length > 2 && ` and ${lowStockProducts.length - 2} more`}
//             </p>
//           </div>
//           <button onClick={() => navigate('/inventory/stocks')} className="btn-action-small">
//             View All
//           </button>
//         </div>
//       )}

//       {/* Stats Cards */}
//       <div className="stats-grid">
//         <div className="stat-card">
//           <div className="stat-icon">📦</div>
//           <div className="stat-content">
//             <div className="stat-label">Total Products</div>
//             <div className="stat-value">{stats.totalProducts}</div>
//             <div className="stat-trend">Active in inventory</div>
//           </div>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon">⚠️</div>
//           <div className="stat-content">
//             <div className="stat-label">Low Stock Items</div>
//             <div className="stat-value">{stats.lowStockItems}</div>
//             <div className="stat-trend">Needs attention</div>
//           </div>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon">📋</div>
//           <div className="stat-content">
//             <div className="stat-label">Pending Orders</div>
//             <div className="stat-value">{stats.pendingOrders}</div>
//             <div className="stat-trend">Awaiting processing</div>
//           </div>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon">🏭</div>
//           <div className="stat-content">
//             <div className="stat-label">Active Warehouses</div>
//             <div className="stat-value">{stats.activeWarehouses}</div>
//             <div className="stat-trend">All operational</div>
//           </div>
//         </div>
//       </div>

//       {/* ⭐ AI Insights Banner — 2 cards, each a distinct destination */}
//       <div className="ai-insights-banner">
//         <div className="ai-banner-header">
//           <div className="ai-banner-title">
//             <span className="ai-icon">🤖</span>
//             <h3>AI-Powered Insights</h3>
//             <span className="beta-badge">Live</span>
//           </div>
//           <button className="btn-link" onClick={() => navigate('/analytics')}>
//             View Full Analytics Dashboard →
//           </button>
//         </div>

//         <div className="ai-insights-grid">
//           {/* Card 1 → Product performance page */}
//           <div
//             className="ai-insight-card clickable"
//             onClick={() => navigate('/analytics/products')}
//           >
//             <div className="insight-icon">📦</div>
//             <div className="insight-content">
//               <div className="insight-label">Product Performance</div>
//               <div className="insight-value">Which products make you money</div>
//               <div className="insight-desc">Top sellers, slow movers, restock suggestions</div>
//             </div>
//           </div>

//           {/* Card 2 → Customer insights page */}
//           <div
//             className="ai-insight-card clickable"
//             onClick={() => navigate('/analytics/customers')}
//           >
//             <div className="insight-icon">👥</div>
//             <div className="insight-content">
//               <div className="insight-label">Customer Insights</div>
//               <div className="insight-value">Who is buying — and what to do</div>
//               <div className="insight-desc">VIP, at-risk, and lost customers with suggested actions</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content Grid */}
//       <div className="dashboard-grid">
//         {/* Low Stock Table */}
//         {lowStockProducts.length > 0 && (
//           <div className="dashboard-card">
//             <div className="card-header">
//               <h3>🚨 Low Stock Alert</h3>
//               <button onClick={() => navigate('/inventory/stocks')} className="btn-primary-small">
//                 View All →
//               </button>
//             </div>
//             <div className="card-content">
//               <table className="low-stock-table">
//                 <thead>
//                   <tr>
//                     <th>Product</th>
//                     <th>Current Stock</th>
//                     <th>Reorder Level</th>
//                     <th>Warehouse</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {lowStockProducts.map(stock => (
//                     <tr key={stock.id}>
//                       <td className="product-name">{stock.product_name}</td>
//                       <td>{stock.quantity} units</td>
//                       <td>{stock.reorder_level || 10} units</td>
//                       <td>{stock.warehouse_name}</td>
//                       <td>
//                         <span className={`status-badge ${getStockStatus(stock.quantity, stock.reorder_level).toLowerCase().replace(' ', '-')}`}>
//                           {getStockStatus(stock.quantity, stock.reorder_level)}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* Quick Actions */}
//         <div className="dashboard-card">
//           <div className="card-header">
//             <h3>🎯 Quick Actions</h3>
//           </div>
//           <div className="card-content">
//             <div className="quick-actions-grid">
//               <button
//                 className="action-btn"
//                 onClick={() => navigate('/orders/new')}
//               >
//                 <span className="action-icon">📦</span>
//                 <div className="action-text">
//                   <div className="action-title">Create New Order</div>
//                   <div className="action-desc">Start a new sales order</div>
//                 </div>
//               </button>

//               <button
//                 className="action-btn"
//                 onClick={() => navigate('/inventory/new')}
//               >
//                 <span className="action-icon">➕</span>
//                 <div className="action-text">
//                   <div className="action-title">Add Product</div>
//                   <div className="action-desc">Add new inventory item</div>
//                 </div>
//               </button>

//               <button
//                 className="action-btn"
//                 onClick={() => navigate('/inventory/stock-transfer')}
//               >
//                 <span className="action-icon">🔄</span>
//                 <div className="action-text">
//                   <div className="action-title">Transfer Stock</div>
//                   <div className="action-desc">Move between warehouses</div>
//                 </div>
//               </button>

//               <button
//                 className="action-btn"
//                 onClick={() => navigate('/inventory/stocks')}
//               >
//                 <span className="action-icon">📊</span>
//                 <div className="action-text">
//                   <div className="action-title">View Stock Levels</div>
//                   <div className="action-desc">Check all warehouse stock</div>
//                 </div>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Recent Activity */}
//       {recentActivity.length > 0 && (
//         <div className="dashboard-card">
//           <div className="card-header">
//             <h3>📈 Recent Activity</h3>
//           </div>
//           <div className="card-content">
//             <div className="activity-list">
//               {recentActivity.map((activity, index) => (
//                 <div key={index} className="activity-item">
//                   <span className="activity-dot"></span>
//                   <div className="activity-content">
//                     <span className="activity-message">{activity.message}</span>
//                     <span className="activity-time">{activity.time}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Dashboard;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { dbHelpers } from '../../db/database';
import { warehousesAPI } from '../../api/warehouses';
import syncService from '../../services/syncService';
import { filterWarehouses } from '../../utils/permissions';
import TrialBanner from '../common/TrialBanner';
import './Dashboard.css';


function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalProducts: 0,
    lowStockItems: 0,
    pendingOrders: 0,
    activeWarehouses: 0,
    totalRevenue: 0
  });
  const [lowStockProducts, setLowStockProducts] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    loadDashboardData();
    loadSubscriptionData();

    const isNewUser = sessionStorage.getItem('newRegistration');
    if (isNewUser === 'true') {
      sessionStorage.removeItem('newRegistration');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    }
  }, []);

  async function loadSubscriptionData() {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8009/api';
      const token = localStorage.getItem('access_token');
      if (!token) return;

      const response = await fetch(`${API_URL}/subscriptions/status/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSubscriptionData(data);
      }
    } catch (error) {
      // Silently fail — subscription banner is non-critical
    }
  }

  // ⭐ Extracted calculation logic — used by both cached and fresh data
  function processDashboardData(products, stocks, orders, warehousesArray) {
    const accessibleWarehouses = filterWarehouses(warehousesArray);
    const accessibleWarehouseIds = accessibleWarehouses.map(w => w.id);

    const filteredStocks = stocks.filter(stock =>
      accessibleWarehouseIds.includes(stock.warehouse_id || stock.warehouse)
    );

    const filteredOrders = orders.filter(order =>
      accessibleWarehouseIds.includes(order.warehouse_id || order.warehouse)
    );

    const accessibleProductIds = new Set(
      filteredStocks.map(stock => stock.product_id || stock.product)
    );
    const filteredProducts = products.filter(p => accessibleProductIds.has(p.id));

    const lowStock = filteredStocks.filter(stock => {
      const quantity = parseInt(stock.quantity) || 0;
      const reorderLevel = parseInt(stock.reorder_level) || 10;
      return quantity <= reorderLevel;
    });

    const pending = filteredOrders.filter(o =>
      o.status === 'pending' || o.status === 'confirmed'
    );

    const revenue = filteredOrders
      .filter(o => o.status === 'delivered')
      .reduce((sum, o) => sum + parseFloat(o.total || 0), 0);

    setStats({
      totalProducts: filteredProducts.length,
      lowStockItems: lowStock.length,
      pendingOrders: pending.length,
      activeWarehouses: accessibleWarehouses.filter(w => w.is_active !== false).length,
      totalRevenue: revenue
    });

    const lowStockWithDetails = lowStock.map(stock => {
      const product = filteredProducts.find(p =>
        p.id === (stock.product_id || stock.product)
      );
      const warehouse = accessibleWarehouses.find(w =>
        w.id === (stock.warehouse_id || stock.warehouse)
      );
      return {
        ...stock,
        product_name: product?.name || stock.product_name || 'Unknown',
        warehouse_name: warehouse?.name || stock.warehouse_name || 'Unknown',
      };
    }).slice(0, 5);

    setLowStockProducts(lowStockWithDetails);
    generateRecentActivity(filteredOrders, filteredStocks);
  }

  async function loadDashboardData() {
    setLoading(true);

    // ⭐ STEP 1: Load from IndexedDB immediately — stops spinner right away
    try {
      const [products, stocks, orders, cachedWarehouses] = await Promise.all([
        dbHelpers.getProducts(),
        dbHelpers.getStocks(),
        dbHelpers.getOrders(),
        dbHelpers.getWarehouses(),
      ]);

      if (cachedWarehouses.length > 0) {
        processDashboardData(products, stocks, orders, cachedWarehouses);
        setLoading(false); // ⭐ Stop spinner with cached data
      }
    } catch (err) {
      console.error('Cache load failed:', err);
    }

    // ⭐ STEP 2: Fetch fresh data from API in background
    if (navigator.onLine) {
      try {
        const warehousesResponse = await warehousesAPI.getAll();
        const warehousesArray = warehousesResponse.data?.results ||
          warehousesResponse.data || [];

        if (warehousesArray.length > 0) {
          await dbHelpers.saveWarehouses(warehousesArray);
        }

        const [products, stocks, orders] = await Promise.all([
          dbHelpers.getProducts(),
          dbHelpers.getStocks(),
          dbHelpers.getOrders(),
        ]);

        // ⭐ Silently update UI with fresh data
        processDashboardData(products, stocks, orders, warehousesArray);
      } catch (err) {
        console.error('Background refresh failed:', err);
        // Already showing cached data — nothing else to do
      }
    }

    setLoading(false);
  }

  function generateRecentActivity(orders, stocks) {
    const activities = [];

    const recentOrders = orders
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(0, 3);

    recentOrders.forEach(order => {
      activities.push({
        type: 'order',
        message: `Order #${String(order.id).substring(0, 8)} ${order.status}`,
        time: formatTimeAgo(order.created_at)
      });
    });

    const recentStocks = stocks
      .filter(s => s.updated_at)
      .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
      .slice(0, 2);

    recentStocks.forEach(stock => {
      activities.push({
        type: 'stock',
        message: `Stock updated: ${stock.product_name} (${stock.quantity} units)`,
        time: formatTimeAgo(stock.updated_at)
      });
    });

    setRecentActivity(activities);
  }

  function formatTimeAgo(timestamp) {
    if (!timestamp) return 'Just now';
    const now = Date.now();
    const time = new Date(timestamp).getTime();
    const diff = Math.floor((now - time) / 1000);

    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  }

  async function handleSync() {
    setSyncing(true);
    const result = await syncService.fullSync();
    if (result.success) {
      await loadDashboardData();
    }
    setSyncing(false);
  }

  function getStockStatus(quantity, reorderLevel) {
    const qty = parseInt(quantity) || 0;
    const reorder = parseInt(reorderLevel) || 10;
    if (qty === 0) return 'OUT OF STOCK';
    if (qty <= reorder) return 'LOW STOCK';
    return 'IN STOCK';
  }

  if (loading) {
    return (
      <div className="dashboard">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard fade-in">
      {/* Welcome Toast */}
      {showToast && (
        <div className="welcome-toast">
          <div className="toast-icon">🎉</div>
          <div className="toast-content">
            <strong>Welcome to TaalumaERP!</strong>
            <p>Your 14-day free trial has started. Explore all features!</p>
          </div>
          <button className="toast-close" onClick={() => setShowToast(false)}>×</button>
        </div>
      )}

      {/* Trial Banner */}
      <TrialBanner subscriptionData={subscriptionData} />

      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Dashboard</h1>
          <p className="welcome-text">Welcome back, {user?.organization?.name || user?.username}!</p>
        </div>
        <button onClick={handleSync} className="btn-sync" disabled={syncing}>
          {syncing ? '⟳ Syncing...' : '🔄 Sync'}
        </button>
      </div>

      {/* Low Stock Alert */}
      {stats.lowStockItems > 0 && (
        <div className="alert-banner alert-warning">
          <span className="alert-icon">⚠️</span>
          <div className="alert-content">
            <strong>{stats.lowStockItems} products below reorder level!</strong>
            <p>
              {lowStockProducts.map(s => s.product_name).slice(0, 2).join(', ')}
              {lowStockProducts.length > 2 && ` and ${lowStockProducts.length - 2} more`}
            </p>
          </div>
          <button onClick={() => navigate('/inventory/stocks')} className="btn-action-small">
            View All
          </button>
        </div>
      )}

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-content">
            <div className="stat-label">Total Products</div>
            <div className="stat-value">{stats.totalProducts}</div>
            <div className="stat-trend">Active in inventory</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <div className="stat-label">Low Stock Items</div>
            <div className="stat-value">{stats.lowStockItems}</div>
            <div className="stat-trend">Needs attention</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📋</div>
          <div className="stat-content">
            <div className="stat-label">Pending Orders</div>
            <div className="stat-value">{stats.pendingOrders}</div>
            <div className="stat-trend">Awaiting processing</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏭</div>
          <div className="stat-content">
            <div className="stat-label">Active Warehouses</div>
            <div className="stat-value">{stats.activeWarehouses}</div>
            <div className="stat-trend">All operational</div>
          </div>
        </div>
      </div>

      {/* AI Insights Banner */}
      <div className="ai-insights-banner">
        <div className="ai-banner-header">
          <div className="ai-banner-title">
            <span className="ai-icon">🤖</span>
            <h3>AI-Powered Insights</h3>
            <span className="beta-badge">Live</span>
          </div>
          <button className="btn-link" onClick={() => navigate('/analytics')}>
            View Full Analytics Dashboard →
          </button>
        </div>

        <div className="ai-insights-grid">
          <div
            className="ai-insight-card clickable"
            onClick={() => navigate('/analytics/products')}
          >
            <div className="insight-icon">📦</div>
            <div className="insight-content">
              <div className="insight-label">Product Performance</div>
              <div className="insight-value">Which products make you money</div>
              <div className="insight-desc">Top sellers, slow movers, restock suggestions</div>
            </div>
          </div>

          <div
            className="ai-insight-card clickable"
            onClick={() => navigate('/analytics/customers')}
          >
            <div className="insight-icon">👥</div>
            <div className="insight-content">
              <div className="insight-label">Customer Insights</div>
              <div className="insight-value">Who is buying — and what to do</div>
              <div className="insight-desc">VIP, at-risk, and lost customers with suggested actions</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="dashboard-grid">
        {lowStockProducts.length > 0 && (
          <div className="dashboard-card">
            <div className="card-header">
              <h3>🚨 Low Stock Alert</h3>
              <button onClick={() => navigate('/inventory/stocks')} className="btn-primary-small">
                View All →
              </button>
            </div>
            <div className="card-content">
              <table className="low-stock-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Current Stock</th>
                    <th>Reorder Level</th>
                    <th>Warehouse</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {lowStockProducts.map(stock => (
                    <tr key={stock.id}>
                      <td className="product-name">{stock.product_name}</td>
                      <td>{stock.quantity} units</td>
                      <td>{stock.reorder_level || 10} units</td>
                      <td>{stock.warehouse_name}</td>
                      <td>
                        <span className={`status-badge ${getStockStatus(stock.quantity, stock.reorder_level).toLowerCase().replace(' ', '-')}`}>
                          {getStockStatus(stock.quantity, stock.reorder_level)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Quick Actions */}
        <div className="dashboard-card">
          <div className="card-header">
            <h3>🎯 Quick Actions</h3>
          </div>
          <div className="card-content">
            <div className="quick-actions-grid">
              <button className="action-btn" onClick={() => navigate('/orders/new')}>
                <span className="action-icon">📦</span>
                <div className="action-text">
                  <div className="action-title">Create New Order</div>
                  <div className="action-desc">Start a new sales order</div>
                </div>
              </button>

              <button className="action-btn" onClick={() => navigate('/inventory/new')}>
                <span className="action-icon">➕</span>
                <div className="action-text">
                  <div className="action-title">Add Product</div>
                  <div className="action-desc">Add new inventory item</div>
                </div>
              </button>

              <button className="action-btn" onClick={() => navigate('/inventory/stock-transfer')}>
                <span className="action-icon">🔄</span>
                <div className="action-text">
                  <div className="action-title">Transfer Stock</div>
                  <div className="action-desc">Move between warehouses</div>
                </div>
              </button>

              <button className="action-btn" onClick={() => navigate('/inventory/stocks')}>
                <span className="action-icon">📊</span>
                <div className="action-text">
                  <div className="action-title">View Stock Levels</div>
                  <div className="action-desc">Check all warehouse stock</div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      {recentActivity.length > 0 && (
        <div className="dashboard-card">
          <div className="card-header">
            <h3>📈 Recent Activity</h3>
          </div>
          <div className="card-content">
            <div className="activity-list">
              {recentActivity.map((activity, index) => (
                <div key={index} className="activity-item">
                  <span className="activity-dot"></span>
                  <div className="activity-content">
                    <span className="activity-message">{activity.message}</span>
                    <span className="activity-time">{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;